var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkmodeSortBy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_5113_6461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.980469 4.21491C0.980469 3.79412 1.32159 3.453 1.74237 3.453H15.4566C15.8774 3.453 16.2186 3.79412 16.2186 4.21491C16.2186 4.6357 15.8774 4.97682 15.4566 4.97682H1.74237C1.32159 4.97682 0.980469 4.6357 0.980469 4.21491ZM2.50428 8.78634C2.50428 8.36555 2.84539 8.02443 3.26618 8.02443H13.9329C14.3537 8.02443 14.6948 8.36555 14.6948 8.78634C14.6948 9.20713 14.3537 9.54825 13.9329 9.54825H3.26618C2.84539 9.54825 2.50428 9.20713 2.50428 8.78634ZM4.02809 13.3578C4.02809 12.937 4.36921 12.5959 4.79 12.5959H12.4091C12.8298 12.5959 13.1709 12.937 13.1709 13.3578C13.1709 13.7786 12.8298 14.1197 12.4091 14.1197H4.79C4.36921 14.1197 4.02809 13.7786 4.02809 13.3578Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5113_6461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.599609 0.784302)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkmodeSortBy);
export default __webpack_public_path__ + "static/media/darkmodeSortBy.6315ea99dcc693a0af9069c2d7023e60.svg";
export { ForwardRef as ReactComponent };